"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenueType = void 0;
var VenueType;
(function (VenueType) {
    /**
     * Default type
     */
    VenueType["Other"] = "Other";
    /**
     * Primary issuance
     */
    VenueType["Distribution"] = "Distribution";
    /**
     * Offering/Fundraise
     */
    VenueType["Sto"] = "Sto";
    VenueType["Exchange"] = "Exchange";
})(VenueType = exports.VenueType || (exports.VenueType = {}));
//# sourceMappingURL=types.js.map